import PropTypes from 'prop-types';

import { useNavigate } from 'react-router-dom';
import Box, { BoxProps as MuiBoxProps } from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Helmet from '../../components/Helmet';

import { Checkout as ClassityCheckout } from '@classity-edtech/ui-order';
import { windowExists } from '@classity-edtech/ui-base';
import { FreeFormName, PaymentStatuses } from '@classity-edtech/platform-utils';
import { useResetResponseCacheMutation } from '../../services/response';

import { webPaths } from '../../routes/paths';
import { parseToken } from '../../utils';

export interface HomeProps extends MuiBoxProps {}

export const Checkout = ({ className }: HomeProps) => {
  const navigate = useNavigate();
  const [resetResponse] = useResetResponseCacheMutation();
  const token = windowExists && parseToken((windowExists?.localStorage as any)?.getItem('token'));

  const clearResponse = () => {
    resetResponse({ userId: token.user });
    localStorage.removeItem('lastQuestionnaire');
    localStorage.removeItem('responses');
    localStorage.removeItem('userFlow');
  };

  const handleEnrolmentNavigation = () => {
    clearResponse();
    navigate(
      `/${webPaths.studentEnrolment}?screen=1&formName=${FreeFormName.REGISTRATIONS_STUDENT}`,
    );
  };

  const handleDashboardNavigation = () => {
    navigate(`/${webPaths.dashboard}`);
  };

  const handleSuccess = (response: any) => {
    clearResponse();
    navigate(
      `/${webPaths.orderConfirmation}?paymentStatus=${PaymentStatuses.SUCCEEDED}&transactionId=${response.tx_ref}&transactionRef=${response.transaction_id}`,
    );
  };

  return (
    <>
      <Helmet />

      <ClassityCheckout
        dashboardNavigation={handleDashboardNavigation}
        enrolmentNavigation={handleEnrolmentNavigation}
        handleSuccess={handleSuccess}
      />
    </>
  );
};

Checkout.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

Checkout.defaultProps = {
  children: null,
  className: null,
};

export default styled<any>(Checkout)(
  ({ theme }) => `
  &.MuiBox-root {
    background-color: ${theme.palette.background.paper};
  }
`,
);
